<template>
  <div>
    <v-row class="grey darken-4 mx-0 d-block rounded">
      <v-col md="3" xs="3" sm="6" class="d-sm-inline-block">
        <c-select
          rotulo="Opções de busca"
          label="Opções de Busca"
          itemText="label"
          itemValue="value"
          :lista="options"
          :item.sync="selectedOption.option"
          v-model="selectedOption.option"
          dense
          dark
          outlined
          auto-select-first
          progress
          :disable-lookup="true"
          :clearable="false"
          @input="changeOrdem($event)"
          @clear="changeOrdem($event)"
        />
      </v-col>
      <v-col md="3" xs="3" sm="6" class="d-sm-inline-block">
        <c-select
          rotulo="Filtro"
          label="Filtro"
          itemText="label"
          itemValue="value"
          :lista="optionsFilter"
          :item.sync="selectedOption.optionFilter"
          v-model="selectedOption.optionFilter"
          dense
          dark
          outlined
          auto-select-first
          progress
          :disable-lookup="true"
          :clearable="false"
          @input="changeFiltro($event)"
          @clear="changeFiltro($event)"
        />
      </v-col>
      <v-col md="3" xs="3" sm="6" class="d-sm-inline-block">
        <v-text-field
          placeholder="Termo da busca"
          class="text-caption"
          outlined
          label="Busca"
          dense
          persistent-hint
          dark
          min="1"
          :maxlength="maxLengthSearch"
          :type="fieldTypeSearch"
          v-model="searchFields.text"
        />
      </v-col>
    </v-row>
    <index-buttons
      @search="sendSearch()"
      @register="create()"
      @changeHeader="changeHeaderDialog = !changeHeaderDialog"
    />
    <megabit-base-dialog
      :showDialog="dialogCreate"
      :width="1400"
      :persistent="false"
    >
    </megabit-base-dialog>
    <v-row>
      <v-col cols="12">
        <megabit-table
          class="elevation-1"
          dense
          dark
          hide-default-footer
          :table-header="tableHeaderSelected"
          :table-items="companyListsListComputed"
          :loading="loadingItems"
          @item-selected="selectItem($event)"
          :itens-per-page="pagination.per_page"
          route="company-list.register"
          :doDelete="doDelete"
          chave="SEQUENCIAL"
          :disable-sort="disableSort"
        >
        </megabit-table>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" class="d-inline-flex">
        <v-pagination
          class="ml-auto"
          :length="pagination.last_page"
          total-visible="6"
          v-model="pagination.current_page"
          @input="changePage($event)"
          :disabled="loadingItems"
        >
        </v-pagination>
      </v-col>
    </v-row>
    <router-view />
    <change-header
      v-model="tableHeaderAvaiable"
      :showDialog="changeHeaderDialog"
      @close="changeHeaderDialog = !changeHeaderDialog"
      :name="headerName"
    />
  </div>
</template>

<script>
import { companyListMixin } from '@/mixins/object/company-list/CompanyListMixin'
import { tableMixin } from '@/mixins/component/table/TableMixin'
import { headerMixin } from '@/mixins/component/table/HeaderMixin'
import { mapActions, mapState } from 'vuex'
import BaseDialog from '@/components/shared/base-dialog/BaseDialog'
import MegabitTable from '@/components/shared/table/MegabitTable'
import cSelect from '@/components/shared/base-input/BaseSelect.vue'
import IndexButtons from '@/components/shared/base-buttons/IndexButtons'

export default {
  mixins: [companyListMixin, tableMixin, headerMixin],
  components: {
    'megabit-base-dialog': BaseDialog,
    MegabitTable,
    cSelect,
    IndexButtons,
  },
  data: () => {
    return {
      fieldTypeSearch: 'number',
      maxLengthSearch: '9',
      headerName: 'companyListIndex',
      disableSort: false,
      dialogCreate: false,
      searchFields: {
        text: '',
      },
      // Opções para o select de BUSCA
      options: [
        { label: 'Código', value: 'codigo', type: 'number', maxlength: 9 },
        {
          label: 'Nome Empresa',
          value: 'nomeempresa',
          type: 'text',
          maxlength: 35,
        },
        { label: 'Data', value: 'data', type: 'date', maxlength: 10 },
        { label: 'Título', value: 'nome', type: 'text', maxlength: 35 },
        { label: 'Vendedor', value: 'vendedor', type: 'text', maxlength: 50 },
      ],
      selectedOption: {
        // Opção selecionada de BUSCA
        option: {
          label: 'Código',
          value: 'codigo',
          type: 'number',
          maxlength: 9,
        },
        // Opção selecionada de FILTRO
        optionFilter: { label: 'A vencer', value: 'avencer' },
      },
      // Opções para o select de FILTRO
      optionsFilter: [
        { label: 'Todas', value: 'todas' },
        { label: 'A vencer', value: 'avencer' },
        { label: 'Vencidas', value: 'vencidas' },
      ],
      tableHeaderAvaiable: [
        {
          text: 'CODIGO',
          value: 'CODIGO',
          show: true,
        },
        {
          text: 'NOME',
          value: 'NOMEEMPRESA',
          show: true,
        },
        {
          text: 'TÍTULO',
          value: 'NOME',
          show: true,
        },
        {
          text: 'DATA',
          value: 'DATA',
          show: true,
        },
        {
          text: 'VENDEDOR',
          value: 'VENDEDOR',
          show: true,
        },
        {
          text: 'DATA INCLUSÃO',
          value: 'DATAINCLUSAO',
          show: true,
        },
        {
          text: 'Ações',
          value: 'controls',
          align: 'right',
          show: true,
        },
      ],
    }
  },
  computed: {
    ...mapState('companyListModule', [
      'loadingItems',
      'pagination',
      'companyListsList',
    ]),
    companyListsListComputed() {
      const list = this.companyListsList.map((e) => ({
        ...e,
        NOMEEMPRESA: e.empresa.NOME,
      }))
      return list
    },
  },
  mounted: function() {
    this.updateSort()
    this.sendSearch()
    this.mountHeader()
  },
  methods: {
    ...mapActions('companyListModule', [
      'getCompanyListsList',
      'getCompanyLists',
      'deleteCompanyList',
    ]),
    ...mapActions({
      setShowLoadingDialog: 'dialogModule/setShowLoadingDialog',
      setLoadingDialogMessage: 'dialogModule/setLoadingDialogMessage',
    }),
    // Desabilita a ordenação em telas pequenas "xs"
    updateSort() {
      let name = this.$vuetify.breakpoint.name
      this.disableSort = name == 'xs' ? true : false
    },
    changePage(page) {
      if (page) this.companyListQuery.page = page
      else this.companyListQuery.page = this.pagination.currentPage
      this.sendSearch('changePage')
    },
    openUpdate() {
      if (!this.selectedItem.SEQUENCIAL)
        this.$toasted.error('Selecione um registro.')
      else {
        this.$router.push({
          name: 'company-list.update',
          params: { id: this.selectedItem.SEQUENCIAL },
        })
      }
    },
    create() {
      this.$router.push({ name: 'company-list.register' })
    },

    async doDelete(item) {
      if (!item) this.$toasted.error('Selecione um registro.')
      else {
        try {
          const response = await this.deleteCompanyList(item.SEQUENCIAL)
          this.$toasted.success(response)
        } catch (error) {
          this.$toasted.error(error, { duration: null })
        }
      }
    },

    changeFiltro($event) {
      if (!$event) {
        this.selectedOption.optionFilter = {
          label: 'A vencer',
          value: 'avencer',
        }
        return
      }
    },
    changeOrdem($event) {
      if (!$event) {
        this.selectedOption.option = { label: 'Código', value: 'codigo' }
        return
      }
      Object.keys(this.companyListQuery).forEach((e) => {
        if (e != 'page' && e != 'todos') {
          if (e != $event) {
            this.companyListQuery[e] = ''
          }
        }
      })
      let o = this.options.filter((e) => e.value == $event.value)
      this.selectedOption.option = o[0]
      this.fieldTypeSearch = this.selectedOption.option.type
      this.maxLengthSearch = this.selectedOption.option.maxlength
      this.searchFields.text = ''
      this.companyListsList.sort((a, b) => {
        if ($event === 'codigo') {
          return a.CODIGO > b.CODIGO ? 1 : b.CODIGO > a.CODIGO ? -1 : 0
        } else if ($event === 'nome') {
          return a.NOME > b.NOME ? 1 : b.NOME > a.NOME ? -1 : 0
        } else if ($event === 'data') {
          return a.DATA > b.DATA ? 1 : b.DATA > a.DATA ? -1 : 0
        } else if ($event === 'vendedor') {
          return a.VENDEDOR > b.VENDEDOR ? 1 : b.VENDEDOR > a.VENDEDOR ? -1 : 0
        }
      })
    },

    async sendSearch(type = 'search') {
      try {
        let searchText = ''
        if (type == 'changePage') {
          searchText = this.companyListQuery[this.selectedOption.option.value]
        } else {
          this.cleanSearch()
          this.companyListQuery.page = 1
          searchText = this.searchFields.text
        }

        if (searchText !== '') {
          switch (this.selectedOption.option.value) {
            case 'nome':
              this.companyListQuery.nome = searchText
              break
            case 'data':
              this.companyListQuery.data = searchText
              break
            case 'vendedor':
              this.companyListQuery.vendedor = searchText
              break
            case 'nomeempresa':
              this.companyListQuery.nomeempresa = searchText
              break
            default:
              if (searchText.toString().length > 9) {
                searchText = searchText.substring(0, 8)
                this.searchFields.text = searchText
              }
              this.companyListQuery.codigo = searchText

              break
          }
        }
        this.companyListQuery.filtro = this.selectedOption.optionFilter.value
        await this.getCompanyListsList(this.companyListQuery)
        // this.cleanSearch()
      } catch (error) {
        this.$toasted.error(error, { duration: null })
      }
    },
    cleanSearch() {
      Object.keys(this.companyListQuery).forEach((e) => {
        if (e != 'page' && e != 'todos') {
          this.companyListQuery[e] = ''
        }
      })
    },
  },
}
</script>

<style></style>
